import React from 'react'
import { useCancelDisbursementInstructionMutation } from '../../../api-services/payments/paymentsApi'
import { setNotification } from '../ui-widgets/uiWidgetsSlice'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../app/hooks'
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import ButtonLoadingComponent from '../../../views/components/shared/ButtonLoadingComponent'

interface CancelDisbursementInstructionComponentProps {
  assetHolderId: number
  instructionId: number
  onSuccess: () => void
  onCloseDialog: () => void
}

const CancelDisbursementInstructionComponent: React.FC<CancelDisbursementInstructionComponentProps> = ({ instructionId, onSuccess, assetHolderId, onCloseDialog }) => {
  const [apiCancelInstruction, { isLoading }] = useCancelDisbursementInstructionMutation()
  const dispatch = useAppDispatch()

  const handleCancelInstruction = (): void => {
    apiCancelInstruction({ assetHolderId, body: { instructionId, otp: '-' } })
      .unwrap()
      .then(() => {
        onSuccess()
        dispatch(setNotification({ open: true, severity: 'success', message: 'The disbursement instruction has been cancelled.' }))
        onCloseDialog()
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
        onCloseDialog()
      })
  }

  return (
    <>
      <Dialog
        open={true}
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => { onCloseDialog() }}
      >
        <DialogTitle>Cancel Disbursement Instruction</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Typography variant={'body1'}>You are about to cancel a disbursement instruction. Please continue if you are sure.</Typography>
            </Grid>
            <Grid item md={12}>
              <Button
                variant={'contained'}
                type="button"
                onClick={() => { handleCancelInstruction() }}
                sx={{ mr: 2 }}
              >
                Cancel Instruction
                {isLoading && <ButtonLoadingComponent/>}
              </Button>
              <Button
                variant={'outlined'}
                type="button"
                onClick={() => { onCloseDialog() }}
                sx={{ mr: 2 }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default CancelDisbursementInstructionComponent
